var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"searchList"},[_c('top-component'),_vm._v(" "),_c('div',{staticClass:"Coalition-content"},[_c('SearchComponent',{on:{"submitForm":_vm.submitForm}})],1),_vm._v(" "),_c('bottom-component')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ccdcf8a8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/search/SearchList.vue
// module id = null
// module chunks = 